export default __webpack_public_path__ + "assets/media/Bottom_Banner_WEB.1149f180.webp";